import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';
import { UserBoardService } from 'src/app/services/user-board.service';
import {  UserBoard } from 'src/app/services/models/user-board.model';


@Component({
    selector: 'bhub-board-home',
    templateUrl: './board-home.component.html',
    styleUrls: ['./board-home.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class BoardHomeComponent extends BasePageComponent implements OnInit {
  boards: UserBoard[] = []; // all available boards
  selectedTabIndex = 0;

  constructor(
    private userBoardService: UserBoardService,
  ) {
    super()
  }

  public ngOnInit() {
    // Define the initial tiles
    this.userBoardService.getUserBoards().subscribe((userBoardList: UserBoard[]) => {
      this.boards = userBoardList;
    });
  }

}

